import formatMoney from '../formatMoney';

const updatePerTabletPrice = (optionValue, variantsData, perTabletPriceEls) => {
  if (!perTabletPriceEls.length) return;

  const matchingDoseVariants = variantsData.filter(variant => { return variant.option1 === optionValue; });
  if (!matchingDoseVariants.length) return;

  const getPerTabletPriceHTML = (price, amountPer, perDoseLanguage) => {
    return `
      ${formatMoney(price / amountPer)} 
      <span class="ml-0.5">${perDoseLanguage}</span>
    `;
  };

  matchingDoseVariants.forEach(variant => {
    const qtyMatch = variant.title.match(/\d+/);
    const variantAmountPer = qtyMatch ? parseInt(qtyMatch[0], 10) : 0;
    const matchingPerPriceEl = [...perTabletPriceEls].find(el => el.getAttribute('data-product-dose') == variantAmountPer);
    if (matchingPerPriceEl) {
      const perDoseLanguage = matchingPerPriceEl.getAttribute('data-product-per-price');
      matchingPerPriceEl.innerHTML = getPerTabletPriceHTML(variant.price, variantAmountPer, perDoseLanguage);

      const selectedVariantOptionEl = matchingPerPriceEl.closest('[data-variant-select-item]');
      if(selectedVariantOptionEl) {
        const selectedLabelEl = selectedVariantOptionEl.querySelector('[data-variants-selected-option]');
        const selectedLabelPerDoseEl = selectedLabelEl.querySelector(`[data-product-dose="${variantAmountPer}"]`);
        if (selectedLabelPerDoseEl) {
          selectedLabelPerDoseEl.innerHTML = getPerTabletPriceHTML(variant.price, variantAmountPer, perDoseLanguage);
        }
      }
    }
  });
};

export default updatePerTabletPrice;